module.exports = __webpack_public_path__ + "static/media/img9.2578670a.png";